import React, { forwardRef, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import en from "date-fns/locale/en-US";
import ja from "date-fns/locale/ja";

import "./DatePicker.scss";
import { useIntl } from "react-intl";
import { useFormatter } from "hooks/intl";
import classNames from "classnames";

registerLocale("en", en);
registerLocale("ja", ja);

const isMobile = navigator.userAgent.match(
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/
);

const CustomInput = forwardRef(
  (
    {
      value,
      onClick,
      className,
    }: {
      value: string | undefined | null;
      className: string;
      onClick: React.MouseEventHandler<HTMLDivElement>;
    },
    ref
  ) => (
    <div className={className} onClick={onClick}>
      {value}&nbsp;
    </div>
  )
);
CustomInput.displayName = "CustomDatePickerInput";

export const DatePickerStyled = ({
  date,
  onChange,
  className,
}: {
  date: Date | null;
  onChange: (value: number) => void;
  className: string;
}) => {
  const onDateChangedHandler = (value: Date) =>
    onChange(value ? value.getTime() : Date.now());
  const { locale } = useIntl();
  const { formatMessage } = useFormatter();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DatePicker
      locale={locale}
      dateFormat={formatMessage("Calendar.DateFormat")}
      dateFormatCalendar={formatMessage("Calendar.YearMonthFormat")}
      selected={date}
      onChange={onDateChangedHandler}
      onCalendarOpen={() => setIsOpen(true)}
      onCalendarClose={() => setIsOpen(false)}
      className={classNames(className, isOpen && "focused")}
      customInput={
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isMobile ? <CustomInput {...({} as any)} /> : undefined
      }
    />
  );
};

export const DateTimePickerStyled = ({
  date,
  onChange,
  className,
}: {
  date: Date | null;
  onChange: (value: number) => void;
  className: string;
}) => {
  const onDateChangedHandler = (value: Date) =>
    onChange(value ? value.getTime() : Date.now());
  const { locale } = useIntl();
  const { formatMessage } = useFormatter();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DatePicker
      locale={locale}
      dateFormat={formatMessage("Calendar.DateTimeFormat")}
      dateFormatCalendar={formatMessage("Calendar.YearMonthFormat")}
      selected={date}
      onChange={onDateChangedHandler}
      onCalendarOpen={() => setIsOpen(true)}
      onCalendarClose={() => setIsOpen(false)}
      className={classNames(className, isOpen && "focused")}
      showTimeInput
      customInput={
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isMobile ? <CustomInput {...({} as any)} /> : undefined
      }
    />
  );
};

export default DatePickerStyled;
